<template>
  <div>
    <page-header :title="$t('scope.text_287')" />
    <page-body>
      <report-project-list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import reportProjectList from './components/List'

export default {
  name: 'reportProject',
  components: {
    reportProjectList,
  },
  data () {
    return {
      listId: 'reportProjectList',
    }
  },
}
</script>
<style lang="less" scoped>
  .page-title-desc {
    color: #5F6368;
    font-size: 16px;
  }
</style>
